import { render, staticRenderFns } from "./AdminViewProjectLogDisputeModal.vue?vue&type=template&id=1564a430&scoped=true&"
import script from "./AdminViewProjectLogDisputeModal.vue?vue&type=script&lang=js&"
export * from "./AdminViewProjectLogDisputeModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewProjectLogDisputeModal.vue?vue&type=style&index=0&id=1564a430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564a430",
  null
  
)

export default component.exports